import { useTranslation } from 'next-i18next'
import { Fade } from 'react-awesome-reveal'
import { css } from '@emotion/react'

import CustomReveal from '@/components/common/CustomReveal'
import { colors } from '@/styles/theme'
import { mediaUp } from '@/styles/media'
import { H3Styles, Text2Styles } from '@/styles/typography'
import { Grid, mediaColumns } from '@/styles/grid'
import { focusVisible, underlineHover } from '@/styles/mixins'
import Title from '@/components/common/Title'
import TextWithButton from '@/components/common/TextWithButton'

import Link from '@/components/common/Link'
import { NAVIGATION_ICONS } from '@/constants/navigationAssets'

function TouchSection() {
  const { t } = useTranslation('landing')

  return (
    <section css={container} id="touch-section">
      <CustomReveal>
        <>
          <Title text={t('saudiExpo.touch.title')} css={title} light />
        </>
      </CustomReveal>
      <Fade>
        <>
          <Grid>
            <div css={columnLeft}>
              <ul css={team}>
                <li css={person}>
                  <div css={personImage}>
                    <img
                      src={
                        'https://cdn.naviparking.com/digital_parking/img/person-marek.webp'
                      }
                      alt={t('saudiExpo.person1.name')}
                    />
                  </div>
                  <div css={description}>
                    <p css={fullName}>
                      {t('saudiExpo.person1.name')}
                      <Link
                        href={`${t('saudiExpo.person1.linkedin')}`}
                        passHref
                        legacyBehavior
                      >
                        <a target="_blank">
                          <img
                            src={NAVIGATION_ICONS.linkedin}
                            alt="LinkedIn"
                            css={icon}
                            loading="lazy"
                          />
                        </a>
                      </Link>
                    </p>
                    <p css={job}>{t('saudiExpo.person1.job')}</p>
                    <Link
                      href={`tel:${t('saudiExpo.person1.phone')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person1.phone')}</a>
                    </Link>
                    <Link
                      href={`mailto:${t('saudiExpo.person1.mail')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person1.mail')}</a>
                    </Link>
                  </div>
                </li>
                <li css={person}>
                  <div css={personImage}>
                    <img
                      src={
                        'https://cdn.naviparking.com/digital_parking/img/person-ahmed.webp'
                      }
                      alt={t('saudiExpo.person2.name')}
                    />
                  </div>
                  <div css={description}>
                    <p css={fullName}>
                      {t('saudiExpo.person2.name')}
                      <Link
                        href={`${t('saudiExpo.person2.linkedin')}`}
                        passHref
                        legacyBehavior
                      >
                        <a target="_blank">
                          <img
                            src={NAVIGATION_ICONS.linkedin}
                            alt="LinkedIn"
                            css={icon}
                            loading="lazy"
                          />
                        </a>
                      </Link>
                    </p>
                    <p css={job}>{t('saudiExpo.person2.job')}</p>
                    <Link
                      href={`tel:${t('saudiExpo.person2.phone')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person2.phone')}</a>
                    </Link>
                    <Link
                      href={`mailto:${t('saudiExpo.person2.mail')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person2.mail')}</a>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
            <div css={columnRight}>
              <ul css={team}>
                <li css={person}>
                  <div css={personImage}>
                    <img
                      src={
                        'https://cdn.naviparking.com/digital_parking/img/person-viktoriia.webp'
                      }
                      alt={t('saudiExpo.person3.name')}
                    />
                  </div>
                  <div css={description}>
                    <p css={fullName}>
                      {t('saudiExpo.person3.name')}
                      <Link
                        href={`${t('saudiExpo.person3.linkedin')}`}
                        passHref
                        legacyBehavior
                      >
                        <a target="_blank">
                          <img
                            src={NAVIGATION_ICONS.linkedin}
                            alt="LinkedIn"
                            css={icon}
                            loading="lazy"
                          />
                        </a>
                      </Link>
                    </p>
                    <p css={job}>{t('saudiExpo.person3.job')}</p>
                    <Link
                      href={`tel:${t('saudiExpo.person3.phone')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person3.phone')}</a>
                    </Link>
                    <Link
                      href={`mailto:${t('saudiExpo.person3.mail')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person3.mail')}</a>
                    </Link>
                  </div>
                </li>
                <li css={person}>
                  <div css={personImage}>
                    <img
                      src={
                        'https://cdn.naviparking.com/digital_parking/img/person-sarah.webp'
                      }
                      alt={t('saudiExpo.person4.name')}
                    />
                  </div>
                  <div css={description}>
                    <p css={fullName}>
                      {t('saudiExpo.person4.name')}
                      <Link
                        href={`${t('saudiExpo.person4.linkedin')}`}
                        passHref
                        legacyBehavior
                      >
                        <a target="_blank">
                          <img
                            src={NAVIGATION_ICONS.linkedin}
                            alt="LinkedIn"
                            css={icon}
                            loading="lazy"
                          />
                        </a>
                      </Link>
                    </p>
                    <p css={job}>{t('saudiExpo.person4.job')}</p>
                    <Link
                      href={`tel:${t('saudiExpo.person4.phone')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person4.phone')}</a>
                    </Link>
                    <Link
                      href={`mailto:${t('saudiExpo.person4.mail')}`}
                      passHref
                      legacyBehavior
                    >
                      <a css={link}>{t('saudiExpo.person4.mail')}</a>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </Grid>
          <div css={buttonMargin}>
            <Grid>
              <TextWithButton
                text={t('saudiExpo.touch.button')}
                button={t('button.more')}
                scrollButton="register-section"
                dark
              />
            </Grid>
          </div>
        </>
      </Fade>
    </section>
  )
}

const container = css`
  background: ${colors.darkSkyBlue};
  padding-bottom: 40px;

  ${mediaUp('lg')} {
    padding-bottom: 80px;
  }
`

const buttonMargin = css`
  margin-top: 12px;

  ${mediaUp('lg')} {
    margin-top: 40px;
  }
`

const columnLeft = css`
  ${mediaColumns({ xs: [12, 0], md: [6, 0] })};
`

const columnRight = css`
  ${mediaColumns({ xs: [10, 1], md: [6, 6] })};
`

const title = css`
  padding: 40px 20px;

  ${mediaUp('md')} {
    br {
      display: none;
    }
  }

  ${mediaUp('lg')} {
    padding: 80px 40px;
  }
`

const team = css`
  counter-reset: step;
  list-style: none;
  display: flex;
  align-items: center;
  flex-direction: column;

  ${mediaUp('md')} {
    align-items: flex-start;
  }
`

const icon = css`
  margin-inline-start: 4px;
  width: 12px;
  height: 12px;

  ${mediaUp('lg')} {
    margin-inline-start: 8px;
    width: 23px;
    height: 23px;
  }
`

const person = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 auto 28px;

  ${mediaUp('md')} {
    margin: 0 0 28px;
    padding-inline-start: 40px;
  }

  ${mediaUp('lg')} {
    margin: 0 0 40px;
  }
`

const personImage = css`
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 18px;

  ${mediaUp('md')} {
    margin-inline-end: 28px;
    margin-bottom: 0;
  }

  ${mediaUp('lg')} {
    width: 118px;
    height: 118px;
    margin-inline-end: 33px;
  }

  img {
    width: 100%;
    height: 100%;
  }
`

const description = css`
  width: 100%;
  text-align: center;

  ${mediaUp('md')} {
    width: auto;
    text-align: start;
  }
`

const fullName = css`
  ${H3Styles};
  color: ${colors.white};
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaUp('md')} {
    justify-content: flex-start;
  }

  ${mediaUp('lg')} {
    margin-bottom: 16px;
  }
`

const job = css`
  ${Text2Styles};
  color: ${colors.white};
`

const link = css`
  ${focusVisible};
  ${Text2Styles};
  ${underlineHover};
  color: ${colors.white};
  display: block;
`

export default TouchSection
